// Display names of core's ids in the current language. Core keeps ids only; these are the one lookup.
import type { ClassId, HeroKind, Role } from '../../core/heroes.js';
import type { ArtifactLine, RelicLine, SkillKey } from '../../core/commands.js';
import type { MonsterKind } from '../../core/monsters.js';
import type { SummonKind } from '../../core/summons.js';
import type { Team } from '../../core/layout.js';
import { t, tMaybe } from './index.js';

export const heroName = (kind: HeroKind) => t(`hero.${kind}` as const);
export const className = (cls: ClassId) => t(`class.${cls}` as const);
export const roleName = (role: Role) => t(`role.${role}` as const);
export const skillName = (kind: HeroKind, key: SkillKey) => t(`skill.${kind}.${key}` as const);
export const passiveName = (kind: HeroKind) => t(`passive.${kind}` as const);
export const artifactName = (line: ArtifactLine) => t(`art.${line}` as const);
export const relicName = (line: RelicLine) => t(`relic.${line}` as const);
export const monsterName = (kind: MonsterKind) => t(`monster.${kind}` as const);
export const summonName = (kind: SummonKind) => t(`summon.${kind}` as const);
/** Short team name («Кровавые» / "Blood"). */
export const teamName = (team: Team) => t(`team.${team}` as const);
/** Full team name («Кровавый оттиск» / "Blood Print"). */
export const teamFullName = (team: Team) => t(`team.${team}.full` as const);
/** A built-in map's name translated; a map the player made keeps its own name. */
export const mapName = (stored: string) => tMaybe(`map.${stored}`) ?? stored;
